import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";

const Testimonials = () => {
  const testimonials = [
    {
      title: "Excellent Airport Service",
      text: "Booked a cab for Pune Airport transfer. The driver arrived on time and the journey was smooth, safe and comfortable.",
      name: "Mr. Rahul Patil",
      profession: "Software Engineer",
    },
    {
      title: "Reliable Outstation Travel",
      text: "We hired an Innova Crysta for Mahabaleshwar. Clean vehicle, professional driver and excellent overall service.",
      name: "Mrs. Sneha Kulkarni",
      profession: "Doctor",
    },
    {
      title: "Best Corporate Cab Service",
      text: "Rising Cab Service provides dependable transportation for our corporate team. Always punctual and professional.",
      name: "Mr. Amit Sharma",
      profession: "Business Owner",
    },
    {
      title: "Comfortable Pune to Mumbai Ride",
      text: "Affordable pricing and hassle-free booking. Highly recommended for airport and outstation travel.",
      name: "Miss Priya Deshmukh",
      profession: "IT Professional",
    },
    {
      title: "Safe Family Journey",
      text: "Our Shirdi trip was comfortable and enjoyable. Driver was courteous and vehicle was well maintained.",
      name: "Mrs. Neha Joshi",
      profession: "Teacher",
    },
    {
      title: "Highly Recommended",
      text: "Excellent customer support and clean vehicles. Will definitely book again with Rising Cab Service.",
      name: "Mr. Sandeep More",
      profession: "Chartered Accountant",
    },
  ];

  return (
    <section
      className="testi-card-area-1 space overflow-hidden p-0 py-2"
      id="testi-sec"
      style={{
        background: "#ffbf91",
      }}
    >
      <div className="container">
        {/* Heading */}
        <div className="row justify-content-center mb-5">
          <div className="col-lg-8">
            <div className="title-area text-center">
              <span
                style={{
                  color: "#F26722",
                  fontWeight: "700",
                  letterSpacing: "2px",
                  textTransform: "uppercase",
                }}
              >
                Customer Reviews
              </span>

              <h2
                className="sec-title"
                style={{
                  color: "#0A2A66",
                }}
              >
                What Our Customers Say
              </h2>

              <p>
                Rising Cab Service is committed to providing safe,
                comfortable and reliable transportation services
                for airport transfers, corporate travel,
                local rides and outstation journeys.
              </p>
            </div>
          </div>
        </div>

        {/* Testimonial Slider */}
        <div className="position-relative p-0">
          <Swiper
            modules={[Autoplay, Navigation]}
            loop={true}
            autoplay={{
              delay: 3500,
              disableOnInteraction: false,
            }}
            navigation={{
              nextEl: ".testimonial-next",
              prevEl: ".testimonial-prev",
            }}
            spaceBetween={25}
            breakpoints={{
              0: {
                slidesPerView: 1,
              },
              768: {
                slidesPerView: 2,
              },
              1200: {
                slidesPerView: 3,
              },
            }}
          >
            {testimonials.map((item, index) => (
              <SwiperSlide key={index}>
                <div
                  style={{
                    background: "#fff",
                    borderRadius: "20px",
                    padding: "30px",
                    boxShadow:
                      "0 10px 30px rgba(0,0,0,0.08)",
                    height: "100%",
                    minHeight: "340px",
                    border: "1px solid #f1f1f1",
                  }}
                >
                  {/* User Icon */}
                  <div
                    style={{
                      width: "70px",
                      height: "70px",
                      borderRadius: "50%",
                      background: "#F26722",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#fff",
                      fontSize: "28px",
                      marginBottom: "20px",
                    }}
                  >
                    <i className="fas fa-user"></i>
                  </div>

                  {/* Stars */}
                  <div
                    style={{
                      marginBottom: "15px",
                    }}
                  >
                    {[...Array(5)].map((_, i) => (
                      <i
                        key={i}
                        className="fas fa-star"
                        style={{
                          color: "#FFC107",
                          marginRight: "4px",
                        }}
                      ></i>
                    ))}
                  </div>

                  {/* Title */}
                  <h4
                    style={{
                      color: "#0A2A66",
                      fontWeight: "700",
                      marginBottom: "15px",
                      fontSize: "22px",
                    }}
                  >
                    {item.title}
                  </h4>

                  {/* Review */}
                  <p
                    style={{
                      color: "#666",
                      lineHeight: "1.8",
                      minHeight: "110px",
                    }}
                  >
                    "{item.text}"
                  </p>

                  {/* Customer Info */}
                  <div
                    style={{
                      borderTop: "1px solid #eee",
                      paddingTop: "15px",
                      marginTop: "15px",
                    }}
                  >
                    <h6
                      style={{
                        marginBottom: "5px",
                        color: "#0A2A66",
                        fontWeight: "700",
                      }}
                    >
                      {item.name}
                    </h6>

                    <span
                      style={{
                        color: "#F26722",
                        fontSize: "14px",
                        fontWeight: "600",
                      }}
                    >
                      {item.profession}
                    </span>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          {/* Left Arrow */}
          <button
            className="testimonial-prev"
            style={{
              position: "absolute",
              left: "-25px",
              top: "50%",
              transform: "translateY(-50%)",
              width: "55px",
              height: "55px",
              borderRadius: "50%",
              border: "none",
              background: "#F26722",
              color: "#fff",
              zIndex: "10",
              boxShadow: "0 8px 20px rgba(0,0,0,0.15)",
            }}
          >
            <i className="fas fa-chevron-left"></i>
          </button>

          {/* Right Arrow */}
          <button
            className="testimonial-next"
            style={{
              position: "absolute",
              right: "-25px",
              top: "50%",
              transform: "translateY(-50%)",
              width: "55px",
              height: "55px",
              borderRadius: "50%",
              border: "none",
              background: "#F26722",
              color: "#fff",
              zIndex: "10",
              boxShadow: "0 8px 20px rgba(0,0,0,0.15)",
            }}
          >
            <i className="fas fa-chevron-right"></i>
          </button>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;